export default __webpack_public_path__ + "static/media/phone.87114850.svg";